//Get Reducer Call--->
export const getExpensecategoryRequest = (page: number, size: number, search: string) => ({
    type: 'GET_EXPENSECATEGORY_REQUEST',
    payload: { page, size, search },
});

export const getExpensecategorySuccess = (data: any) => ({
    type: 'GET_EXPENSECATEGORY_SUCCESS',
    payload: { data },
});

export const getExpensecategoryFailure = (data: string) => ({
    type: 'GET_EXPENSECATEGORY_FAILURE',
    payload: { data },
});

export const resetGetExpensecategory = () => ({
    type: 'RESET_GET_EXPENSECATEGORY',
});

//Create Reducer Call--->
export const createExpensecategoryRequest = (data: any) => ({
    type: 'CREATE_EXPENSECATEGORY_REQUEST',
    payload: data,
});

export const createExpensecategorySuccess = (data: any) => ({
    type: 'CREATE_EXPENSECATEGORY_SUCCESS',
    payload: { data },
});

export const createExpensecategoryFailure = (data: string) => ({
    type: 'CREATE_EXPENSECATEGORY_FAILURE',
    payload: { data },
});

export const resetCreateExpensecategory = () => ({
    type: 'RESET_CREATE_EXPENSECATEGORY',
});

//Update Reducer Call--->
export const updateExpensecategoryRequest = (data: any, id: string) => ({
    type: 'UPDATE_EXPENSECATEGORY_REQUEST',
    payload: { data, id },
});

export const updateExpensecategorySuccess = (data: any) => ({
    type: 'UPDATE_EXPENSECATEGORY_SUCCESS',
    payload: { data },
});

export const updateExpensecategoryFailure = (data: string) => ({
    type: 'UPDATE_EXPENSECATEGORY_FAILURE',
    payload: { data },
});

export const resetUpdateExpensecategory = () => ({
    type: 'RESET_UPDATE_EXPENSECATEGORY',
});
//Delete Reducer Call--->
export const deleteExpensecategoryRequest = (id: string) => ({
    type: 'DELETE_EXPENSECATEGORY_REQUEST',
    payload: { id },
});

export const deleteExpensecategorySuccess = (data: any) => ({
    type: 'DELETE_EXPENSECATEGORY_SUCCESS',
    payload: { data },
});

export const deleteExpensecategoryFailure = (data: string) => ({
    type: 'DELETE_EXPENSECATEGORY_FAILURE',
    payload: { data },
});

export const resetDeleteExpensecategory = () => ({
    type: 'RESET_DELETE_EXPENSECATEGORY',
});
